<template>
  <div class="agreement-page">
    <van-nav-bar
      z-index="9"
      :title="title"
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="agreement-content">
      <iframe :src="'data:text/html;base64,' + base64Str" frameborder="0" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
import routerBack from '@/mixins/routerBack';

export default {
  name: 'AgreementPage',
  mixins: [routerBack],
  data() {
    return {
    };
  },
  computed: {
    title() {
      return this.$route.query.title || 'Agreement';
    },
    base64Str() {
      return this.$store.state.user.agreementContent;
    },
  },
  methods: {
    onClickLeft() {
      this.goBack();
    },
  },
};
</script>
<style lang="less" scoped>
.agreement-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.agreement-content {
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
}
.agreement-content iframe {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
